import { render, staticRenderFns } from "./ComboBoxSelector.vue?vue&type=template&id=55c4e6fa&scoped=true&"
import script from "./ComboBoxSelector.vue?vue&type=script&lang=ts&"
export * from "./ComboBoxSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ComboBoxSelector.vue?vue&type=style&index=0&id=55c4e6fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4e6fa",
  null
  
)

export default component.exports